import { $ } from "./imports";

// Añade titulo segun filtro tags listado blog|noticias

const newsBlogTitle = () => {
    if( $('.blog-filter__list').length > 0){

        function changeTitle(){
            // Obtener filtro|categoria seleccionada
            let title = $('.blog-filter__list form input[type="radio"]:checked').parent('.form-item.form-type-radio').find('label').text().trim();
            
            let template = `<div class="col-12">
                <h2 class="heading--1 blog-results__title text-center">
                    ${title}
                </h2>
            </div>`;

            // Verificar que no exista el titulo
            if( $('.blog-results__title').length <= 0 ){
                // Insertamos template
                $('.blog-filter').after(template);
            }else{
                // Cambiamos titulo
                $('.blog-results__title').text(title);
            }

        }

        changeTitle();

        // Escuchamos cambios
        $('body').on('change', '.blog-filter__list form input[type="radio"]', function(){
            changeTitle();
        });
    }
}

export default newsBlogTitle;